import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography, IconButton } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { orderContext } from '../OrderContext';
import { CircleLoader, DetailsPageHeader } from 'components';
import { applicationContext } from 'helpers/services';
import ReferenceDataKey from 'helpers/enums/ReferenceDataKey';

let OrderDocuments = () => {
    let service = useContext(orderContext);
    let appService = useContext(applicationContext);

    return (
        <DetailsPageHeader sectionName='Order documents'>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <Table size='small'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Document name</TableCell>
                            <TableCell>Document type</TableCell>
                            <TableCell>File name</TableCell>
                            <TableCell align='right' />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {service.order.documents
                            .map((document, index) =>
                                <TableRow hover key={index}>
                                    <TableCell>{document.documentName}</TableCell>
                                    <TableCell>{appService.referenceData[ReferenceDataKey.DocumentType].getValueByKey(document.documentType) ?? ""}</TableCell>
                                    <TableCell>{document.fileName}</TableCell>
                                    <TableCell align='right'>
                                        <IconButton onClick={() => service.downloadDocument(document.documentImportId, document.documentFormat, document.fileName)} style={{ padding: 4 }}>
                                            <DownloadIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )}
                    </TableBody>
                    {(!service.order.documents || service.order.documents.length === 0) &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={6}>
                                    <Typography variant="subtitle2">No order documents found</Typography>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
            }
        </DetailsPageHeader>
    );
}

export default OrderDocuments;